import { Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { filter, map } from 'rxjs/operators';

import {
  DimensionService,
  UnitConverter
} from '@ct-software/ct-ui-core';
import { Channel } from './channel.interface';

@Injectable({
  providedIn: 'root'
})
export class DatascribeChannelsHelper {
  constructor(
    private readonly unitConverter: UnitConverter,
    private readonly dimensionService: DimensionService,
  ) {}

  public getCurrentRawWithLabelsChannels$(channels: Observable<Channel[]>): Observable<Channel[]> {

    return channels
    .pipe(
      filter(Boolean),
      map((channels: Channel[]) => this.mapChannels(channels)),
      map((channels: Channel[]) => this.getDimensionConfig(channels)),
      switchMap(this.bindLabels$.bind(this)),
    );
  }

  public mapChannels(channels: Channel[]): Channel[] {

    return channels.reduce((result, channel) => {

      result.push(
        {
          ...channel,
          displayName: channel.name,
        });

      return result;
    }, []);
  }

  public bindLabels$(channels: Channel[]): Observable<Channel[]> {
    return this.unitConverter.getLabels$(channels.map(x => x.dimensionData.unit))
      .pipe(
        map((labels: string[]) => labels.map((_, index) => ({
          ...channels[index],
          label: labels[index]
        })))
      );
  }

  public getDimensionConfig(channels: Channel[]): Channel[] {
    return channels.map(item => {

      if (item.dimension === 'VOLUME_PER_TIME') {
        item.dimension = 'VOLUME_RATE';
      }
      return {
        ...item,
        dimensionData: this.dimensionService.getConfig(item.dimension || 'NULL')
      };
    });
  }
}
